<template>
  <div>
    <div>
      <AppSetProfileBtn color="blueSecondry" :type="docType" @click="btnClick"/>
    </div>
  </div>
</template>

<script>
import AppSetProfileBtn from '@/components/ui/AppSetProfileBtn'
import { useCurrentUser } from '@/services/useCurrentUser'

export default {
  name: 'ActivitiesDialogRequestFooter',
  components: {
    AppSetProfileBtn,
  },

  props: {
    docType: Number
  },

  setup(props, context) {
    const { currentUser } = useCurrentUser()
    const btnClick = (val) => {
      context.emit("submitType", val)
    }
    return {
      currentUser,
      btnClick
    }
  },
}
</script>
